const EventEmitter = require("events").EventEmitter;

class MyEmitter extends EventEmitter {}

const Emitter = new MyEmitter();

module.exports = { EventEmitter: Emitter };
